import { CheckCircleIcon } from './CheckCircleIcon';

/**
 * author: Google
 * id 93D7B6DC-17D2-4A2B-B787-79E2E8BEF304
 * name check-circle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/check-circle.svg
 * tags
 * - Form 
 */
export const TickCircleIcon = CheckCircleIcon;
export default TickCircleIcon